import { StyleSheet, Text, View } from 'react-native';

import { colors, type } from '@/theme';

type Props = {
  initials: string;
  size?: number;
  /** Selected avatars flip to a solid accent block — the card-game "chosen" state. */
  accent?: string | null;
};

export function Avatar({ initials, size = 56, accent = null }: Props) {
  return (
    <View
      style={[
        styles.base,
        {
          width: size,
          height: size,
          borderRadius: size * 0.32,
          backgroundColor: accent ?? colors.cardHi,
        },
      ]}>
      <Text
        style={[
          styles.text,
          { fontSize: size * 0.32, color: accent ? colors.onGold : colors.dim },
        ]}>
        {initials}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    ...type.title,
    letterSpacing: 0.5,
  },
});
